import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { ChevronLeftIcon, colors } from "@dotnet/telematics-design-system";

import ListChoice from "components/DesignComponents/ListChoice";

import { CONTENT_NAMES, SelectedOptionProps } from "./types";

const GoBack = ({ setContent }: SelectedOptionProps) => {
    const { blue700, white } = colors;

    const { t } = useTranslation();

    return (
        <ListChoice
            title={t("Button##go back")}
            iconLeft={<ChevronLeftIcon />}
            onClick={() => setContent(CONTENT_NAMES.Initial)}
            css={css({
                background: white,
                color: blue700
            })}
        />
    );
};

export default GoBack;
